import {
  createComponentClickedEvent,
  createScreenViewedEvent,
  track,
} from "./base"

export const eventsScreenViewed = ({ eventCount }: { eventCount: number }) => {
  track(
    createScreenViewedEvent({
      current_screen: "Events",
      viewed_values: {
        event_count: eventCount, // Number of events shown on the Events screen
      },
    })
  )
}

export const eventCardClicked = ({
  eventName,
  eventLocation,
}: {
  eventName: string
  eventLocation: string
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Events",
      component_type: "button",
      component_function: "view event details",
      clicked_values: {
        event_name: eventName,
        event_location: eventLocation,
      },
    })
  )
}

export const eventDetailsViewed = ({
  eventName,
  eventLocation,
}: {
  eventName: string
  eventLocation: string
}) => {
  track(
    createScreenViewedEvent({
      current_screen: "Event Details",
      viewed_values: {
        event_name: eventName,
        event_location: eventLocation,
      },
    })
  )
}

export const registerOnEventbriteClicked = ({
  eventName,
  eventLocation,
}: {
  eventName: string
  eventLocation: string
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Event Details",
      component_type: "button",
      component_function: "register on Eventbrite",
      clicked_values: {
        event_name: eventName,
        event_location: eventLocation,
      },
    })
  )
}

export const accessAllWebinarsClicked = () => {
  track(
    createComponentClickedEvent({
      current_screen: "Events",
      component_type: "button",
      component_function: "access all webinars",
    })
  )
}
